export default function GroupedBudgetSkeletonLoader() {
    return <div className="flex w-full flex-grow border rounded-md border-gray-300">
        <div className={`flex flex-grow h-20 bg-gray-200 animate-pulse`}>
        </div>
    </div>
}